import React from 'react';
import { motion } from 'framer-motion';
export function PrivacyPage() {
  return <div className="min-h-screen bg-sovereign-navy text-white pt-32 pb-20" data-id="element-284">
      <div className="container mx-auto px-6 max-w-3xl" data-id="element-285">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-4xl font-serif text-white mb-12" data-id="element-286">
          Privacy Policy
        </motion.h1>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.2
      }} className="prose prose-lg prose-invert prose-headings:font-serif prose-headings:text-white text-gray-400 font-light" data-id="element-287">
          <p data-id="element-288">Last updated: October 2023</p>
          <p data-id="element-289">
            At Sovereign eTims, we prioritize the sanctity of your data. This
            policy outlines our minimalist approach to data collection—we only
            store what is absolutely necessary for compliance.
          </p>
          <h3 data-id="element-290">Data Collection</h3>
          <p data-id="element-291">
            We collect transaction data solely for the purpose of transmitting
            it to the KRA eTims server. This includes invoice numbers,
            transaction amounts, and tax details.
          </p>
          <h3 data-id="element-292">Data Security</h3>
          <p data-id="element-293">
            All data is encrypted in transit and at rest using enterprise-grade
            protocols. We do not sell or share your data with third parties.
          </p>
          <h3 data-id="element-294">Your Rights</h3>
          <p data-id="element-295">
            You retain full sovereignty over your data. You may request an
            export or deletion of your transaction history at any time, subject
            to KRA retention regulations.
          </p>
        </motion.div>
      </div>
    </div>;
}